<template>
  <CoreDialog
    data-qa="dialog-spec-not-available-modal"
    :value="isShowDialog"
    transition="fade-transition"
    size="sm"
  >
    <v-img
      src="/static/_v1/pd/mascots/speciality-empty.svg"
      alt="Маскот ПроДокторов - не найдено"
      height="175px"
      width="175px"
      class="mx-auto mb-2"
      contain
    />
    <div class="text-h6 text--text mb-2">
      Таких врачей в городе нет
    </div>
    <div class="text-body-1 text-secondary--text">
      Врачей
      <template v-if="chosenSpeciality && isSpecialityVisible">
        по специальности {{ chosenSpeciality }}
      </template>
      {{ subtitleText }} нет.
    </div>
    <template #actions>
      <v-btn
        data-qa="modal-actions-btn-close"
        color="primary"
        text
        @click="hideDialog"
      >
        Понятно
      </v-btn>
    </template>
  </CoreDialog>
</template>

<script>
import { deleteQueryParam, getQueryParam } from 'www/utils'
import UserStorage from 'www/modules/UserStorage'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'

export default {
  name: 'DialogSpecNotAvailable',
  components: { CoreDialog },
  props: {
    townName: {
      type: String,
      default: '',
    },
    isDoctorlistOnline: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isShowDialog: false,
    isDoctorlistHome: false,
    isSpecialityVisible: true,
  }),
  computed: {
    chosenSpeciality() {
      return UserStorage.get('chosen-speciality')?.toLowerCase()
    },
    subtitleText() {
      if (this.isDoctorlistHome) {
        return 'с вызовом на дом'
      }

      return this.isDoctorlistOnline ? 'онлайн' : `в городе ${this.townName}`
    },
  },
  created() {
    /**
     * Если перешли на список врачей без доступной специальности,
     * и название этой специальность есть в localStorage,
     * то отображаем диалоговое окно
     */

    if (getQueryParam('spec_not_available') !== null && this.chosenSpeciality) {
      this.isShowDialog = true

      deleteQueryParam('spec_not_available')

      return
    }

    if (getQueryParam('spec_not_available_na_dom') !== null && this.chosenSpeciality) {
      this.isShowDialog = true
      this.isDoctorlistHome = true

      deleteQueryParam('spec_not_available_na_dom')

      return
    }

    if (getQueryParam('not_available_na_dom') !== null) {
      this.isShowDialog = true
      this.isDoctorlistHome = true
      this.isSpecialityVisible = false

      deleteQueryParam('not_available_na_dom')
    }
  },
  methods: {
    hideDialog() {
      this.isShowDialog = false
    },
  },
}
</script>
